


















import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import RootCauseAnswerModel from '@/models/investigation/rootCauseAnswerModel'
import BasicList from '@/components/lists/BasicList.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'

const titleModule = getModule(TitleModule)

@Component({
  components: {
    BasicList
  }
})
export default class SuggestedActions extends Vue {
  @Prop(String) readonly id!: string

  private rootCauseAnswers: Array<RootCauseAnswerModel> = new Array<
    RootCauseAnswerModel
  >()

  async created(): Promise<void> {
    await this.getRootCauseAnswers()
  }

  private async getRootCauseAnswers(): Promise<void> {
    this.rootCauseAnswers = await ApiService.getAllById<RootCauseAnswerModel>(
      UrlType.ExtensionRootCauseAnswerByInvestigation,
      this.id
    )
  }

  private navigate(rootCauseAnswer: RootCauseAnswerModel): void {
    this.$router.push({
      name: 'suggestedAction',
      params: { id: rootCauseAnswer.rootMapId }
    })

    titleModule.setPageTitle(rootCauseAnswer.rootMapDetail)
  }
}
